const API = {
  fcChannel: 11,
  /**
   * =========== AUTHENTICATION APIs ===========
   */


  auth: {
    /**
     * createSession
     * @description Create session and get CSRF Identifier
     */
    createSession: {
      url: '/rest/session/create',
      method: 'GET',
      mode: 'cors',
      credentials: 'same-origin',
    },
    /**
     * isLoggedIn
     * @description Check if the user is logged in
     */
    isLoggedIn: {
      url: '/rest/is-logged-in',
      method: 'GET',
      mode: 'cors',
      credentials: 'same-origin',
    },
    /**
     * loginUser
     * @description signin with username and password
     */
    loginUser: {
      url: '/api/v2/identity/signin/user',
      method: 'POST',
      mode: 'cors',
      credentials: 'include',
    },
    /**
     * createUser
     * @description Create/ SignUP new user
     */
    createUser: {
      url: '/api/v3/identity/create/user/email',
      method: 'POST',
    },
    /**
     * getSessionFromToken
     */
    getSessionFromToken: {
      url: '/api/v2/identity/signin/user/token',
      method: 'POST',
    },
    /**
     * socialLogin
     * @description Login with facebook or google
     */
    socialLogin: {
      url: '/api/v2/identity/social/user',
      method: 'POST',
    },
    /**
     * whoami
     * @description If user is logged-in THEN get user details
     */
    whoami: {
      url: '/rest/whoami',
      method: 'GET',
    },
    fcToken: {
      url: '/rest/fctoken/get',
      method: 'GET',
    },

    userDetails: (email) => {
      return {
        url: `/rest/users/${email}/profile`,
        method: 'GET',
        credentials: 'include',
        mode: 'cors'
      }
    },

    ocstatus: (email) => {
      return {
        url: `/rest/user/${email}/ocstatus`,
        method: 'GET',
        credentials: 'same-origin',
        mode: 'cors',
      }
    }
  },

  /**
   * =========== AUTHENTICATION APIs ===========
   */

  twoFa: {
    verify: {
      url: '/api/v2/identity/users/mobileOnly/verify',
      method: 'POST',
    },

    generateOTP: {
      url: '/api/v2/identity/otp/resend',
      method: 'POST',
    }
  },

  /**
   * =========== PAYMENT APIs ===========
   */

  payment: {
    getBalance: {
      url: '/rest/fcwallet/v1/getbalance',
      method: 'GET',
    },
    userIsVerified: {
      url: '/api/v2/identity/user/is-verified',
      method: 'POST',
    },
    netBankingOptions: {
      url: '/rest/payment/loadmoney/netBankingOptions',
      method: 'GET',
    },
    getAccount: {
      url: '/rest/fcwallet/v1/bank/getaccounts',
      method: 'GET',
    },
    applyPromoCode: {
      url: '/promocodeservice/promocode/applypromo',
      method: 'POST',
    },
    validatePromoCode: {
      url: '/payment/fcwallet/v1/validate/promocode',
      method: 'POST',
    },
    applyFreeFund: {
      url: '/promocode/apply.htm',
      method: 'POST',
    },
    addMoneyInit: {
      url: '/payment/fcwallet/v2/addmoney/init',
      method: 'POST',
    },
    getWithdrawFeeDetails: {
      url: '/rest/fcwallet/v1/getWithdrawFeeDetails',
      method: 'GET',
    },
    generateOTPPayment: {
      url: '/otp/v1/generate',
      // url: '/api/v2/identity/otp/send',
      method: 'POST',
    },
    verifyandwithdraw: {
      url: '/rest/fcwallet/v1/verifyandwithdraw',
      method: 'POST',
    },
    cardBins: {
      url: '/rest/payment/v2/bins',
      method: 'GET',
    }
  },

  /**
  * =========== PAYMENT APIs ===========
  */

  /**
  * =========== BANK ACCOUNT APIs ===========
  */

  bank: {
    getBanks: {
      url: '/rest/fcwallet/v1/bank/getaccounts',
      method: 'GET',
    },
    generateOTPforAddBank: {
      url: ' /rest/fcwallet/v1/generateOtpForAddBankDetails',  
      method: 'POST',
    },
    verifyOTPforAddBank: {
      url: ' /rest/fcwallet/v1/verifyOtpForAddBankDetails',
      method: 'POST',
    },
    generateOTPforupdateBank: {
      url: ' /rest/fcwallet/v1/generateOtpForUpdateBankDetails',
      method: 'POST',
    },
    verifyOTPforupdateBank: {
      url: ' /rest/fcwallet/v1/verifyOtpForUpdateBankDetails',
      method: 'POST'
    },
    getCappingLimitsForUser: {
      url: '/rest/fcwallet/session/v1/getCappingLimitsForUser',
      method: 'GET',
    },
    generateOTPforUpdateLimit: {
      url: '/rest/fcwallet/v1/generateOtpForUpdateCappingLimits',
      method: 'POST',
    },
    verifyOTPforUpdateLimit: {
      url: '/rest/fcwallet/v1/verifyOtpForUpdateCappingLimits',
      method: 'POST',
    }
  },
  /*
  * =========== BANK ACCOUNT APIs ===========
  */
  
  
  /**
   * =========== SAVED CARDS APIs ===========
   */

  savedcards: {
    deleteCard: {
      url: '/rest/fcwallet/v1/cards/delete',
      method: 'POST',
    },
    getStoredCards: {
      url: '/rest/fcwallet/v1/cards/list',
      method: 'GET',
    },
  },

   /**
   * =========== SAVED CARDS APIs ===========
   */

   user: {
     updateProfileName: {
       url: '/api/v2/identity/update/user/name',
       method: 'POST',
     },
     updateMobileNumber: {
       url: '/api/v2/identity/update/user/mobileno',
       method: 'POST',
     },
     linkUser: {
       url: '/api/v2/identity/link/user/email',
       method: 'POST',
     },
     sendOTPToMobile: {
       url: '/api/v2/identity/otp/send',
       method: 'POST',
     },
     sendOTPToEmail: {
       url: '/api/v2/identity/otp/send/email',
       method: 'POST',
     },
     resendOtp: {
       url: '/api/v2/identity/otp/resend',
       method: 'POST',
     },
     updateProfilePassword: {
       url: '/api/v3/identity/change/user/password',
       method: 'POST',
     }
   },

   statement : {
    url: '/api/v0/txnhistoryview/getwallettxnhistoryviewforpreviousmonthsbytoken',
    method: 'POST',
   }
};


export default API;